<script lang="ts">
  // Simple typing indicator component
</script>

<div class="flex items-center gap-2 pl-2">
  <div class="flex items-center gap-1 bg-surface-tertiary rounded-full px-4 py-2">
    <span class="w-2 h-2 bg-gray-400 dark:bg-dark-text-low rounded-full animate-bounce" style="animation-delay: 0ms"></span>
    <span class="w-2 h-2 bg-gray-400 dark:bg-dark-text-low rounded-full animate-bounce" style="animation-delay: 150ms"></span>
    <span class="w-2 h-2 bg-gray-400 dark:bg-dark-text-low rounded-full animate-bounce" style="animation-delay: 300ms"></span>
  </div>
  <span class="text-caption text-content-tertiary">입력 중...</span>
</div>

<style>
  @keyframes bounce {
    0%, 60%, 100% {
      transform: translateY(0);
    }
    30% {
      transform: translateY(-4px);
    }
  }
</style>
